import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../hooks/useAuth';
import { Card, Flex } from 'antd';
import Typography from 'antd/es/typography/Typography';
import { useNavigate } from 'react-router-dom';

export function SignOutPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    auth.signOutCognito();
    navigate({ pathname: '/signin' });
  }, [auth, navigate]);

  return (
    <Flex
      vertical
      style={{
        maxWidth: 500,
      }}
      gap={0}
    >
      <img
        src={`${process.env.PUBLIC_URL}/logo.svg`}
        alt="Logo"
        style={{ alignSelf: 'center', marginBottom: 25 }}
      />
      <Card title={t('auth.signOut')} style={{ minWidth: 320 }}>
        <Typography>{t('auth.signingOut')}</Typography>
      </Card>
    </Flex>
  );
}
